import { Controller } from "@hotwired/stimulus"
import moment from "moment"

export default class extends Controller {
  static targets = ["display"]
  static values = { receivingLastDate: String }

  connect() {
    this.now = moment()
    this.diff = 0
    this.isClosed = false
    
    this.updateCountdown()
    
    this.countDownInterval = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  }

  disconnect() {
    if (this.countDownInterval) {
      clearInterval(this.countDownInterval)
    }
  }

  updateCountdown() {
    this.now = moment()
    this.diff = moment(this.receivingLastDateValue)
      .endOf('day')
      .diff(this.now)
    
    if (this.diff <= 0) {
      this.diff = 0
      this.isClosed = true
      clearInterval(this.countDownInterval)
    }
    
    this.renderDisplay()
  }

  renderDisplay() {
    if (this.isClosed) {
      this.displayTarget.innerHTML = '<p>受付終了</p>'
    } else {
      const days = this.days
      const hours = this.twoDigits(this.hours)
      const minutes = this.twoDigits(this.minutes)
      const seconds = this.twoDigits(this.seconds)
      
      let timeDisplay = `${hours}:${minutes}:${seconds}`
      if (days > 0) {
        timeDisplay = `${days}日&nbsp;${timeDisplay}`
      }
      
      this.displayTarget.innerHTML = `
        <p>
          参加受付終了まで
          <b>
            <span>${timeDisplay}</span>
          </b>
        </p>
      `
    }
  }

  get days() {
    return Math.floor(moment.duration(this.diff).asDays())
  }

  get hours() {
    return moment.duration(this.diff).hours()
  }

  get minutes() {
    return moment.duration(this.diff).minutes()
  }

  get seconds() {
    return moment.duration(this.diff).seconds()
  }

  twoDigits(value) {
    if (value.toString().length <= 1) {
      return '0' + value.toString()
    }
    return value.toString()
  }
} 